module.exports = __webpack_public_path__ + "img/sm-今天是個吃甜點的好日子.b435e6f7.svg";